
export function getAgeValidationParams(confirmCB, cancelCB) {
  return {
    customClass: 'age-validation-modal',
    title: "Are you 21 years old?",
    type: "warning",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    showCancelButton: true,
    showConfirmButton: true,
    html: true,
    onConfirm: confirmCB,
    onCancel: cancelCB,
    confirmButtonColor:"#007792",
  }
}



// WEBPACK FOOTER //
// ./src/utils/swalHelpers.js